import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import SvgButton from '../../../../components/SvgButton';
import SvgSubmitButton from '../../../../components/SvgSubmitButton';

const LoginForm = props => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  const onFormSubmitUserInputs = e => {
    e.preventDefault();
    props.onFormSubmit(login, password);
  };

  return (
    <div className="login-form__wrapper">
      <form className="login-form" action="/" method="POST" autoComplete="off">
        <span className="login-form__wrap">
          <input
            className="login-form__input"
            value={login}
            onChange={e => setLogin(e.target.value)}
            type="email"
            name="login"
            autoComplete="off"
            placeholder="Enter Email Address"
            required=""
          />
          <label className="login-form__label" />
        </span>

        <span className="login-form__wrap">
          <input
            className="login-form__input"
            value={password}
            onChange={e => setPassword(e.target.value)}
            type="password"
            name="password"
            autoComplete="off"
            placeholder="Password"
            required=""
          />
          <label className="login-form__label" />
        </span>

        {props.authError && (
          <span className="login-form__error-message">
            Incorrect login or password.
          </span>
        )}

        <a className="login-form__reset-password-link" href="/reset-password">
          Forgot your password?
        </a>

        <div className="login-form__buttons">
          <div className="login-form__submit-btn">
            <SvgSubmitButton
              btnWidth={100}
              btnHeight={40}
              btnFontWeight={600}
              btnText="Login"
              btnArrow={false}
              controlFunc={onFormSubmitUserInputs}
            />
          </div>

          <div className="login-form__signup-btn">
            <SvgButton
              btnWidth={100}
              btnHeight={40}
              btnFontWeight={700}
              btnHref="/signup"
              btnText="Sign Up"
              btnArrow={false}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

LoginForm.propTypes = {
  onFormSubmit: PropTypes.func.isRequired,
};
export default LoginForm;
